export default function AboutSection() {
  return (
    <section id="about" className="w-full bg-[#F8F9FA] py-24 md:py-32">
      <div className="w-full px-6 md:px-20">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-20">

          {/* Left: Typography */}
          <div className="flex-1">
            <span className="inline-block text-xs font-semibold tracking-[0.3em] uppercase text-gray-400 bg-gray-200 rounded-full px-4 py-1.5 mb-10">
              Who We Are
            </span>
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-black text-gray-900 leading-none tracking-tight">
              <span className="block">Experts</span>
              <span className="block mt-1">in Modern</span>
              <span className="block mt-1">iOS Dev.</span>
            </h2>
            <p className="mt-10 text-gray-500 text-base font-light leading-relaxed max-w-md">
              MEDEST D.O.O. is a specialized team of software engineers and security
              researchers focused exclusively on the iOS platform. We craft applications
              that protect, optimize, and empower millions of users worldwide.
            </p>
            <p className="mt-4 text-gray-500 text-base font-light leading-relaxed max-w-md">
              Founded in Serbia, our international team brings together deep expertise
              in mobile security, UX design, and systems optimization — delivering
              products that consistently rank among the highest-rated on the App Store.
            </p>


          </div>

          {/* Right: Card */}
          <div className="lg:w-[420px] xl:w-[480px]">
            <div
              className="rounded-[40px] p-8 md:p-10 flex flex-col justify-between min-h-[420px]"
              style={{ background: "linear-gradient(135deg, #0a2e2a 0%, #0d3d34 50%, #0f4a3f 100%)" }}
            >
              <div className="flex items-center justify-between">
                <span className="text-white/40 text-xs tracking-widest uppercase">Our Mission</span>
                <div className="flex gap-1.5">
                  <div className="w-2 h-2 rounded-full bg-white/20"></div>
                  <div className="w-2 h-2 rounded-full bg-white/40"></div>
                  <div className="w-2 h-2 rounded-full bg-white/70"></div>
                </div>
              </div>

              <div className="mt-8">
                <p className="text-white text-2xl md:text-3xl font-light leading-relaxed">
                  &ldquo;We believe every mobile user
                  deserves enterprise-grade
                  security and a seamless,
                  optimized experience — right
                  in their pocket.&rdquo;
                </p>
              </div>

              <div className="mt-8 flex items-center gap-4">
                <img
                  src="https://public.readdy.ai/ai/img_res/abfde8d45e844913df8f1ab349ff472d.jpg"
                  alt="Team lead"
                  className="w-12 h-12 rounded-full object-cover object-top"
                />
                <div>
                  <p className="text-white text-sm font-semibold">Nikola Petrović</p>
                  <p className="text-white/50 text-xs mt-0.5">Lead iOS Engineer, MEDEST D.O.O.</p>
                </div>
              </div>
            </div>

            {/* Secondary card */}
            <div className="mt-4 rounded-2xl bg-white p-6 flex items-center gap-4">
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-emerald-50">
                <i className="ri-shield-check-line text-emerald-600 text-lg"></i>
              </div>
              <div>
                <p className="text-gray-900 font-semibold text-sm">Privacy-First Development</p>
                <p className="text-gray-400 text-xs mt-0.5">Every line of code is reviewed for security compliance</p>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}
